import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const add_white = (urlOrAddress, description) => {
  return api.post(`${ApiEndpointConstants.ADDWHITE}`, {
    urlOrAddress,
    description,
  });
};
